<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened" :zIndex="999999999")
    .b-confirm-popup
      ._text(v-if="text" v-html="preparedText")
      ._text(v-else)
        slot
      ._desc(v-if="desc" v-html="preparedDesc")
      ._buttons
        Btn(blue @click="close(true)" data-testid="confirm-ok") Да
        Btn(grey @click="close(false)" data-testid="confirm-cancel") Нет
</template>

<script>
import BasePopup from '@/components/BasePopup.vue';
import colorify from '@/utils/colorify';
import htmlspecialchars from '@/utils/htmlspecialchars';

export default {
  name: 'PopupConfirm',
  components: { BasePopup },
  controller: null,
  data() {
    return {
      isOpened: false,
      text: '',
      desc: '',
    };
  },
  computed: {
    preparedText() { return colorify(htmlspecialchars.encode(this.text)); },
    preparedDesc() { return colorify(htmlspecialchars.encode(this.desc)); },
  },
  methods: {
    open(text, desc = '') {
      this.isOpened = true;
      this.text = text;
      this.desc = desc;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<style scoped lang="scss">
  .confirm-popup {
    max-width: 536px;

    &__text {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.02em;
      margin-bottom: 40px;
    }

    &__desc {
      letter-spacing: 0.02em;
      margin-bottom: 40px;
      text-align: center;
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 30px;
    }
  }
</style>
